import { render, staticRenderFns } from "./ProdOutMater.vue?vue&type=template&id=6bc4ad5c&scoped=true&"
import script from "./ProdOutMater.vue?vue&type=script&lang=js&"
export * from "./ProdOutMater.vue?vue&type=script&lang=js&"
import style0 from "./ProdOutMater.vue?vue&type=style&index=0&id=6bc4ad5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc4ad5c",
  null
  
)

export default component.exports